<template>
  <v-card class="h-100" rounded="lg">
    <v-card-text class="pa-6">
      <h2 class="text-h2 text-center font-weight-medium mb-1">
        {{ value.amount }}
      </h2>
      <p class="text-body-0 text-center font-weight-bold">
        {{ value.subtitle }}
      </p>
    </v-card-text>
  </v-card>
</template>

<script setup>
defineProps({
  value: {
    required: true,
    type: Object
  }
})
</script>
